const doc = [({"da":({"js":({"admin":({"sheet_sizes":({"select":({"choose_sheet_size":"Vælg arkstørrelse"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;